import { Select, DatePicker, Button, Spin, Tag, message, Input } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import gination from "./gination";
import { format } from "../../App";
import {
  countCanclePolicy,
  pad,
  postData,

} from "../../data/allfunction";
import { delUser, setUser } from "../../app/features/user/userSlice";
import { useHistory } from "react-router-dom";
import { PDFViewer, PDFDownloadLink } from "@react-pdf/renderer";
import PDFReport from "./PDFReport_2";
import { changLgValue, getDataPost_2, getPDF_2, logout } from "../../data/allfunction_2";
import { showDetail } from "./Total_2";

const dateFormat = "DD-MM-YYYY HH:mm:ss";
const { Option } = Select;
const ip = process.env.REACT_APP_IP;
const QR = process.env.REACT_APP_QR;

function TotalNo_2(props) {
  let {
    setdatasentPDF,
    setModalShow,
    button_pfd,
    showModalDetail,
    setdrivercover_option,
  } = props;
  const dispatch = useDispatch();
  const history = useHistory();
  const userRedux = useSelector((state) => {
    return state.user;
  });
  const { value } = useSelector((state) => state.lg);
  const [dataPolicies, setDatapolicies] = useState([]);
  const [currenPage, setcurrenPage] = useState(1);
  const [limitPage, setlimitPage] = useState(10);
  const [amountPage, setamountPage] = useState(0);
  const [amountRows, setamountRows] = useState(0);
  const [loading, setloading] = useState(false);
  const [users, setUsers] = useState([]);
  const [sent_startCover, setsent_startCover] = useState();
  const [sent_endCover, setsent_endCover] = useState();
  const [sent_user_name, setsent_user_name] = useState("");
  const [sent_user, setsent_user] = useState();
  const [confirm, setconfirm] = useState(true);
  const [total, settotal] = useState({});
  const [premuim, setpremuim] = useState(0);
  const [total_premuim, settotal_premuim] = useState(0);
  const [commission, setcommission] = useState(0);
  const [ZJIIncom, setZJIIncom] = useState(0);
  const [total_zji_get, settotal_zji_get] = useState(0);
  const [totaldipos, settotaldipos] = useState(0);
  const [ZJItax, setZJItax] = useState(0);
  const [countCancle, setcountCancle] = useState(0);

  const [dataPoliciesPdf, setDatapoliciesPdf] = useState([]);
  const [total_premuim_pdf, settotal_premuim_pdf] = useState(0);
  const [premuim_pdf, setpremuim_pdf] = useState(0);
  const [commission_pdf, setcommission_pdf] = useState(0);
  const [ZJIIncom_pdf, setZJIIncom_pdf] = useState(0);
  const [totaldipos_pdf, settotaldipos_pdf] = useState(0);
  const [ZJItax_pdf, setZJItax_pdf] = useState(0);
  const [countCancle_pdf, setcountCancle_pdf] = useState(0);

  const [statusPdf, setstatusPdf] = useState(false);
  const [groupNum, setGroupNum] = useState("");

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const getUser = useCallback(async () => {
    let all = {
      id: 0,
      name: "ຕົວແທນທັງໝົ້ດ",
    };
    let link = `${ip}sell_online/users`;
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };
    try {
      const response = await fetch(link, requestOptions);
      const result_1 = await response.json();
      if (result_1.status === 200) {
        if (userRedux.level === "manager" || userRedux.level === "acc") {
          let u = result_1.data;
          u.unshift(all);
          setUsers(u);
        } else {
          const uu = result_1.data.find((id) => id.id === userRedux.user_id);
          setUsers([uu]);
        }
      } else {
      }
    } catch (error) {
      return console.log("error", error);
    }
  }, [userRedux.level, userRedux.user_id]);
  // --------------------------getData--------
  async function getPDF() {
    setloading(true);
    let link = `${ip}sell_online/policiesPDF`;
    let dataSetForGet = {
      date_start: sent_startCover,
      date_end: sent_endCover,
      agent: sent_user,
    };
    let user = userRedux.user;
    let retoken = userRedux.retoken;
    let token = userRedux.token;
    function setWhenUpdate(result) {
      // console.log(result)
      if (result.data.status === 200) {
        let { data, total } = result.data;

        if (data.length > 0) {
          let cancel = 0;
          let de = data.map((e) => {
            cancel += countCanclePolicy(e.cancel);
            return e;
          });

          // console.log(result.data)

          setDatapoliciesPdf(de);
          settotal_premuim_pdf(total.total_Net_premuim);
          setpremuim_pdf(total.total_premuim);
          setcommission_pdf(total.total_AjentCommission);
          setZJIIncom_pdf(total.zjiIncom);
          setZJItax_pdf(total.total_tax);
          settotaldipos_pdf(total.totaldipos);
          setcountCancle_pdf(cancel);
        } else {
          setDatapoliciesPdf([]);
          message.success(
            `ບໍ່ພົບສັນຍາ ລະວ່າງວັນທີ ${moment(sent_startCover).format(
              "DD-MM-YYYY"
            )} - 
                         ${moment(sent_endCover).format("DD-MM-YYYY")} ໃນລະບົບ`
          );
        }
        setTimeout(() => {
          setloading(false);
        }, 100);
      } else {
        setTimeout(() => {
          setloading(false);
        }, 100);
      }
    }
    postData(
      message,
      link,
      dataSetForGet,
      token,
      retoken,
      user,
      dispatch,
      delUser,
      setUser,
      history,
      setWhenUpdate
    );
  }
  // ---------------------------end getData---

  async function getData() {
    // setloading(true);
    let link = `${ip}sell_online/policiesPaginationNum`;
    let dataSetForGet = {
      page: currenPage,
      limit: limitPage,
      num: groupNum,
      agent: sent_user,
    };
    let user = userRedux.user;
    let retoken = userRedux.retoken;
    let token = userRedux.token;
    function setWhenUpdate(result) {
      console.log(result);
      if (result.data.status === 404) {
        setloading(false);
        message.error(result.data.msg);
      } else if (result.data.status === 200) {
        let { data, total } = result.data;
        // console.log(data)
        if (data.length > 0) {
          let cancel = 0;
          let de = data.map((e) => {
            cancel += countCanclePolicy(e.cancel);
            return e;
          });

          settotal(total);
          settotal_premuim(total.total_Net_premuim);
          setpremuim(total.total_premuim);
          setcommission(total.total_AjentCommission);
          setZJIIncom(total.zjiIncom);
          settotal_zji_get(total.total_zji_get);
          settotaldipos(total.totaldipos);
          setZJItax(total.total_tax);
          setcountCancle(cancel);
          setDatapolicies(de);
          setamountPage(result.data.amountPage);
          setamountRows(result.data.amountRows);
        } else {
          setDatapolicies([]);
          setamountRows(0);
          message.error("ເກີດຂໍ້ຜິດພາດ ກະລຸນາກວດສອບການປ້ອນເລກທີສັນຍາໃຫ້ຖືກ");
        }
        setTimeout(() => {
          setloading(false);
        }, 100);
      } else {
        setTimeout(() => {
          setloading(false);
        }, 100);
      }
    }
    postData(
      message,
      link,
      dataSetForGet,
      token,
      retoken,
      user,
      dispatch,
      delUser,
      setUser,
      history,
      setWhenUpdate
    );
  }

  useEffect(() => {
    getUser();
  }, [getUser]);

  useEffect(() => {
    if (
      sent_startCover !== undefined ||
      sent_endCover !== undefined ||
      sent_user !== undefined
    ) {
      getData();
    }
  }, [currenPage, limitPage]);
  useEffect(() => {
    if (groupNum === "") {
      setconfirm(true);
    } else {
      setconfirm(false);
    }
  });

  // -------------onchange
  function onchange_user(value) {
    let name = users.find((e) => e.id === value);
    setsent_user_name(name.name);
    console.log(name.user);
    if (name.user == undefined) {
      setsent_user(0);
    } else {
      setsent_user(name.user);
    }

    // console.log(name.user);
  }
  function onChange_timestart(value, dateString) {
    setsent_startCover(value);
  }
  function onChange_timeend(value, dateString) {
    setsent_endCover(value);
  }
  function onchange_limit(value) {
    setcurrenPage(1);
    setlimitPage(value);
  }

  async function getData() {
    console.log(sent_user);
    try {
      let dataSetForGet = {
        no: groupNum,
        user: sent_user,
      };
      console.log(dataSetForGet);
      let l = ip + "sell_2_online/cacurate_no_user";
      let data = await getDataPost_2(
        l,
        dataSetForGet,
        userRedux.token,
        userRedux.retoken
      );
      //  console.log(data);

      setDatapolicies(data);

      if (data == null) {
        throw new Error(data);
      } else {
        // console.log(data);
        let _total_premuim = 0;
        let _premuim = 0;
        let _diposit = 0;
        let _commission = 0;
        let _zji_get = 0;
        let _zji_total_get = 0;
        let policyCancel = 0;
        let _total = 0;
        data.forEach((oneData) => {
          //console.log(oneData);
          _total++;
          _total_premuim += oneData.total_premuim;
          _premuim += oneData.premuim;
          _diposit += oneData.diposit;
          _commission += oneData.commission;
          _zji_get += oneData.zji_get;
          _zji_total_get += oneData.zji_total_get;
          policyCancel += oneData.cancel === 1 ? 1 : 0;
        });

        settotal_premuim(_total_premuim);
        setpremuim(_premuim);
        settotaldipos(_diposit);
        setZJItax(_commission);
        setZJIIncom(_zji_get);
        settotal_zji_get(_zji_total_get);
        setcountCancle(policyCancel);
        settotal({
          _total_premuim,
          _premuim,
          _diposit,
          _commission,
          _zji_get,
          _zji_total_get,
          policyCancel,
          _total,
        });
      }
    } catch (error) {
      alert("ໂທກເຄັນທ່ານໝົ້ດອາຍຸ ກະລຸນາເຂົ້າສູ່ລະບົບໃໝ່");
    }
  }

  return (
    <div>
      {" "}
      {/* totalNo_2 */}
      <Select
        // placeholder="ເລືອກຕົວແທນ"
        placeholder={changLgValue(value, 71)}
        optionFilterProp="children"
        style={{ width: "100%" }}
        onChange={onchange_user}
      >
        {users.map((value) => {
          return (
            <Option key={value.id} value={value.id}>
              {value.name} ({value.user})
            </Option>
          );
        })}
      </Select>
      <hr />
      <div style={{ display: "flex", flexDirection: "row" }}>
        <div style={{ flex: 4 }}>
          <Input
            // placeholder="ກະລຸນາພິມເລກທີສັນຍາໃນຮູບແບບ 1 ໃນກໍລະນີຄົ້ນຫາສັນຍາດຽວ ແລະ   1,5,3,7  ໃນກໍລະນີຕ້ອງການຄົ້ນຫລາຍສັນຍາ"
            placeholder={changLgValue(value, 81)}
            onChange={(e) => {
              setGroupNum(e.target.value);
            }}
          />
        </div>
        <div style={{ flex: 1, marginLeft: 5 }}>
          <Button
            disabled={confirm}
            onClick={() => {
              setstatusPdf(false);
              getData();
            }}
            style={{ width: "100%" }}
            type="primary"
          >
            {changLgValue(value, 78)}
            {/* ຄົ້ນຫາ{" "} */}
          </Button>
        </div>
      </div>
      {loading && (
        <div
          style={{
            position: "absolute",
            top: "20%",
            left: "45%",
          }}
        >
          <Spin tip="ກຳລັງໂຫລດຂໍ້ມູນ..." />
        </div>
      )}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          marginTop: 10,
        }}
      >
        <div>
          <h5>
            {/* ຈຳນວນສັນຍາທັງໝົ້ດ {dataPolicies.length} ສັນຍາ */}

            {/* ຈຳນວນສັນຍາທັງໝົ້ດ  */}
            {changLgValue(value, 79)}
            {dataPolicies.length}
            {"  "}
            {/* ສັນຍາ */}
            {" "}
            {changLgValue(value, 80)}
          </h5>
        </div>
      </div>

      {showTable()}

      {dataPolicies.length > 0 && showDetail(total)}
      <div className="mb-2 mt-2" style={{ paddingTop: 5, float: "right" }}>
        {dataPolicies.length > 0 ? (
          statusPdf ? (
            <Button
              type="primary"
              onClick={() => {
                setTimeout(() => {
                  //     setDatapolicies([]);
                  setstatusPdf(false);
                }, 3000);
              }}
            >
              <PDFDownloadLink
                document={
                  <PDFReport
                    user={userRedux.user}
                    datas={dataPolicies}
                    total_premuim_ConfirmS={total_premuim}
                    premuim_ConfirmS={premuim}
                    commission_ConfirmS={ZJItax}
                    ZJIIncom_ConfirmS={ZJIIncom}
                    total_zji_get_ConfirmS={total_zji_get}
                    totaldipos_ConfirmS={0}
                    ZJItax_ConfirmS={0}
                    countCancle_ConfirmS={total.policyCancel}
                    policy_no_start={moment(sent_startCover).format(
                      "DD-MM-YYYY"
                    )}
                    policy_no_end={moment(sent_endCover).format("DD-MM-YYYY")}
                    sent_user_name={sent_user_name}
                    where={"dete"}
                  />
                }
                fileName={
                  "ລາຍລະອຽດຕົວແທນ " +
                  sent_user +
                  "/" +
                  sent_user_name +
                  moment(Date.now()).format("DD-MM-YYYY") +
                  ".pdf"
                }
              >
                {({ blob, url, loading, error }) =>
                  loading ? "ກຳລັງດາວໂຫລດ ກະລຸນາລໍຖ້າ..." : "ລາຍງານເປັນ PDF"
                }
              </PDFDownloadLink>
            </Button>
          ) : (
            <Button
              type="primary"
              onClick={() => {
                setstatusPdf(true);
              }}
            >
              {" "}
              ສ້າງ ໃບຮັບເງິນ{" "}
            </Button>
          )
        ) : null}
      </div>
      {/* {dataPolicies.length > 0 && (
        <PDFViewer style={{ width: "100%", height: 500 }}>
          <PDFReport_2
            user={userRedux.user}
            datas={dataPolicies}
            total_premuim_ConfirmS={total_premuim}
            premuim_ConfirmS={premuim}
            commission_ConfirmS={ZJItax}
            ZJIIncom_ConfirmS={ZJIIncom}
            total_zji_get_ConfirmS={total_zji_get}
            totaldipos_ConfirmS={500}
            ZJItax_ConfirmS={ZJItax_pdf}
            countCancle_ConfirmS={countCancle_pdf}
            policy_no_start={moment(sent_startCover).format("DD-MM-YYYY")}
            policy_no_end={moment(sent_endCover).format("DD-MM-YYYY")}
            sent_user_name={sent_user_name}
            where={"dete"}
          />
        </PDFViewer>
      )} */}
    </div>
  );
  function handleClick(no) {
    window.open(QR + no);
  }
  function showTable() {
    return (
      <table className="table table-striped">
        <thead>
          <tr>
            <th>#</th>
            <th>ຕົວແທນຂາຍ</th>
            <th>ເລກທີສັນຍາ</th>


            {isMobile ? <></> : <>
              <th>ເລກທະບຽນ</th>
              <th>ວັນທີສິ້ນສຸດການຄຸ້ມກັນ</th>
              <th>ຊື່ລູກຄ້າ</th>
              <th>ລາຍຮັບທັງໝົ້ດ</th>
              <th>ກ່ອນອາກອນ</th>
              <th>ເປີເຊັນຕົວແທນ (ຄ່າຄອມ-ຈ່າຍຊ້າ)</th>
              {/* <th>ເງິນຝາກຄັງ</th> */}
              <th>ລາຍຮັບຕົວແທນຫັກອາກອນແລ້ວ</th>
              <th>ລາຍຮັບເຂົ້າ ZJI</th>
              <th>ມອບເຂົ້າ ZJI ສຸດທິ</th>
              <th>ວັນທີຄ້າງຈ່າຍ</th>
              <th>ສະຖານະການຊຳລະໃຫ້ຕົວແທນ</th>
              <th>ສະຖານະການຊຳລະໃຫ້ສຳນັກງານ</th>
              <th>ສະຖານະຂອງສັນຍາ</th>
            </>}



            <th>ດາວໂຫລດສັນຍາ</th>
          </tr>
        </thead>
        <tbody>
          {dataPolicies.map((oneData, key) => {
            return (
              <tr key={key}>
                <td>{limitPage * (currenPage - 1) + key + 1}</td>
                <td>{oneData.USER}</td>
                <td>
                  <Button
                    onClick={() => {
                      // console.log(oneData)
                      // setModalShow(true);
                      // setdatasentPDF(oneData);
                      // getOptionDriver(oneData, setdrivercover_option);
                      showModalDetail(oneData.no);
                    }}
                  >
                    {oneData.policy_type}-{pad(oneData.no)}
                  </Button>
                </td>



                {isMobile ? <></> :
                  <>
                    <td>{oneData.o_plate}</td>
                    <td>{moment(oneData.end).format("DD-MM-YYYY HH:mm:ss")}</td>
                    <td>{oneData.o_name}</td>
                    <td style={{ textAlign: "right" }}>
                      {format(oneData.total_premuim)}
                    </td>
                    <td style={{ textAlign: "right" }}>
                      {/* ກ່ອນອາກອນ */}
                      {format(oneData.premuim)}
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                        ...(oneData.enable_pay_late === 1
                          ? { color: "orange" }
                          : {}),
                      }}
                    >
                      {/* ເປີເຊັນຕົວແທນ */}(
                      {oneData.paid === 1
                        ? oneData.commission_percen
                        : format(oneData.commission_percen_first) +
                        "-" +
                        oneData.paylate}
                      )% =
                      {
                        // format(commit(oneData.premuim, dellComis(dateDiff(oneData.dateadd), oneData.Total_MVL, oneData.enable_pay_late), oneData.Diposit))
                        format(oneData.commission_percen)
                      }
                    </td>
                    {/* <td style={{ textAlign: "right" }}>
                ເງິນຝາກຄັງ
                {oneData.diposit_percen}% = {format(oneData.diposit)}
              </td> */}
                    <td style={{ textAlign: "right" }}>
                      {/* ຫັກອາກອນ 5  % */}
                      ອາກອນ {format(oneData.Text116)}% ={format(oneData.commission)}
                    </td>
                    <td style={{ textAlign: "right" }}>
                      {/* ລາຍຮັບເຂົ້າ ZJI */}
                      {
                        // format(incomeZJI(oneData.premuim, oneData.total_premuim, dellComis(dateDiff(oneData.dateadd), oneData.Total_MVL), oneData.Text116, oneData.enable_pay_late, oneData.Diposit))
                        format(oneData.zji_get)
                      }
                    </td>
                    <td style={{ textAlign: "right" }}>
                      {/* ລາຍຮັບເຂົ້າ ZJI ສຸດທິ */}
                      {format(oneData.zji_total_get)}
                    </td>
                    <td>{format(oneData.day_diff)} ວັນ</td>
                    <td>
                      {oneData.emp_paid === 1 ? (
                        <Tag style={{ cursor: "pointer" }} color="geekblue">
                          ການຊຳລະສົມບູນ
                        </Tag>
                      ) : (
                        <Tag style={{ cursor: "pointer" }} color="red">
                          ລໍຖ້າການຊຳລະ
                        </Tag>
                      )}
                    </td>

                    <td>
                      {/* {oneData.paid === 1 ? <Tag style={{ cursor: 'pointer' }} color="geekblue">ການຊຳລະສົມບູນ</Tag> : <Tag style={{ cursor: 'pointer' }} color="red">ລໍຖ້າການຊຳລະ</Tag>} */}
                      {oneData.paid === 1 ? (
                        <Tag
                          style={{ cursor: "pointer" }}
                          color="geekblue"
                          onClick={() => { }}
                        >
                          ການຊຳລະສົມບູນ
                        </Tag>
                      ) : (
                        <Tag
                          style={{ cursor: "pointer" }}
                          color="red"
                          onClick={() => { }}
                        >
                          ລໍຖ້າການຊຳລະ
                        </Tag>
                      )}
                    </td>
                    <td>
                      {oneData.cancel === 1 ? (
                        <Tag
                          style={{ cursor: "pointer" }}
                          onClick={() => { }}
                          color="red"
                        >
                          ຖືກຍົກເລີກ
                        </Tag>
                      ) : (
                        <Tag
                          style={{ cursor: "pointer" }}
                          onClick={() => { }}
                          color="geekblue"
                        >
                          ບໍ່ຖືກຍົກເລີກ
                        </Tag>
                      )}
                    </td>
                  </>}

                <td>
                  <Button
                    onClick={() => {
                      if (oneData.policy_type.toUpperCase() === "MS") {
                        //  console.log("short");
                        let l = ip + "sell_2_online/pdf_short";
                        downloadPDF(
                          oneData.no,
                          l,
                          oneData.policy_type.toUpperCase()
                        );
                      } else {
                        //  console.log("long");
                        let l = ip + "sell_2_online/pdf_log";
                        downloadPDF(
                          oneData.no,
                          l,
                          oneData.policy_type.toUpperCase()
                        );
                      }

                      async function downloadPDF(no, l, policy_type) {
                        let dataSetForGet = { no };
                        let pro = await getPDF_2(
                          l,
                          dataSetForGet,
                          userRedux.token,
                          userRedux.retoken
                        );

                        // Create a temporary URL representing the Blob
                        const url = window.URL.createObjectURL(pro);

                        // Create a link element
                        const a = document.createElement("a");
                        a.href = url;
                        a.download = `${policy_type}-${no}`;

                        // Append the link to the body
                        document.body.appendChild(a);

                        // Trigger a click event on the link to initiate download
                        a.click();

                        // Cleanup
                        window.URL.revokeObjectURL(url);
                        document.body.removeChild(a);
                      }
                    }}
                  >
                    {/* ດາວໂຫລດສັນຍາ */}
                    {oneData.policy_type}-{pad(oneData.no)}
                  </Button>
                </td>
              </tr>
            );
          })}
        </tbody>

        {isMobile ? <></> :
          dataPolicies.length > 0 && (
            <tfoot>
              <tr>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th style={{ textAlign: "right" }}>{format(total_premuim)}</th>
                <th style={{ textAlign: "right" }}>{format(premuim)}</th>
                <th style={{ textAlign: "right" }}>{format(commission)}</th>
                {/* <th style={{ textAlign: "right" }}>{format(totaldipos)}</th> */}
                <th style={{ textAlign: "right" }}>{format(ZJItax)}</th>
                <th style={{ textAlign: "right" }}>{format(ZJIIncom)}</th>
                <th style={{ textAlign: "right" }}>{format(total_zji_get)}</th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </tfoot>
          )}

      </table>
    )
  }
}

export default TotalNo_2;
